import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=2619ecb1&"
import script from "./LanguageSelection.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelection.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=2619ecb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports